
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"currentColor","viewBox":"0 0 18 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 2h-1V1c0-.55-.45-1-1-1s-1 .45-1 1v1H5V1c0-.55-.45-1-1-1S3 .45 3 1v1H2C.89 2 .01 2.9.01 4L0 18a2 2 0 002 2h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 15c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1V7h14v10zM4 9h2v2H4V9zm4 0h2v2H8V9zm4 0h2v2h-2V9z"}})])
          )
        }
      }
    